import { render, staticRenderFns } from "./EditFees.vue?vue&type=template&id=bd5d477c&"
import script from "./EditFees.vue?vue&type=script&lang=js&"
export * from "./EditFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports